<fieldset
  [disabled]="disabled"
  [class.centered]="!disableSpacing"
  [class.nested]="kind === 'nested'"
>
  @if (header) {
    <legend>
      <span class="header-title">{{ header }}</span>
      @if (description) {
        <span class="header-description">{{ description }}</span>
      }
      <ng-content select="[mrFieldsetAction]"></ng-content>
    </legend>
  }
  <ng-content></ng-content>
</fieldset>
